import { render, staticRenderFns } from "./Exceltemplateconfiguration.vue?vue&type=template&id=40f072f0&scoped=true&"
import script from "./Exceltemplateconfiguration.vue?vue&type=script&lang=js&"
export * from "./Exceltemplateconfiguration.vue?vue&type=script&lang=js&"
import style0 from "./Exceltemplateconfiguration.vue?vue&type=style&index=0&id=40f072f0&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f072f0",
  null
  
)

export default component.exports